import { User as AuthenticatedUser } from 'oidc-client-ts';
import { Client, HttpMethod, User } from '@bimone/bimtrack-core';
import { UserAssembler } from './assemblers/UserAssembler';
import { UserDto } from './assemblers/types';

export class UserClientState {
  public readonly STALE_TIME = 1000 * 60 * 2;
  public lastRequestDateTime = 0;
  public lastHubId = '';
}

export default class UserClient {
  public constructor(private readonly authenticatedUser: AuthenticatedUser) {}

  public fetchAuthenticatedUser(): Promise<User> {
    return Promise.resolve(UserAssembler.toDomainFromAuth(this.authenticatedUser));
  }

  public static async fetchUserPreferencesByHub(
    currentUser: User,
    hubId: string,
    bimTrackApiUrl: string,
    accessToken: string,
    userClientState?: UserClientState
  ): Promise<User> {
    const client = new Client<UserDto>({
      baseUrl: bimTrackApiUrl,
      endpoint: `v3/hubs/${hubId}/users/${currentUser.globalId}`,
      token: accessToken,
    });

    if (
      userClientState &&
      userClientState.lastHubId === hubId &&
      Date.now() - userClientState.lastRequestDateTime < userClientState.STALE_TIME
    ) {
      return currentUser;
    }

    const userDto = await client.sendRequest(HttpMethod.GET);

    if (userClientState) {
      userClientState.lastHubId = hubId;
      userClientState.lastRequestDateTime = Date.now();
    }

    return UserAssembler.toDomain(userDto, currentUser);
  }
}
